<section id="address" class="content atendimento">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <h3 class="title"><span>Atendimento</span></h3>
                <p>
                    <b>{{ address.clinic }}</b><br />
                    {{ address.street}}, {{ address.number }}, {{ address.complement }} <br />
                    {{ address.district }} <br />
                    {{ address.city }}, {{ address.state }} - {{ address.zipCode }} <br />
                </p>
                <p>
                    <b>Telefones</b> <br />
                    <span *ngFor="let phone of address.phones">
                        <a href="tel:{{phone.rawNumber}}">{{ phone.formatNumber }}</a> <br />
                    </span>
                </p>
                <p>
                    <b>E-mail</b><br />
                    <a href="mailto:{{email}}">dravanessalago.pneumo@gmail.com</a> <br />
                </p>
            </div>
            <div class="col-lg-8 col-md-6">
                <agm-map [zoom]="address.zoom" [latitude]="address.lat" [longitude]="address.lng">
                    <agm-marker [latitude]="address.lat" [longitude]="address.lng"></agm-marker>
                </agm-map>
            </div>
        </div>
    </div>
</section>